
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import axios from "axios";
import "./TopPicks.css";
import SaleContext from "./context/SaleContext";
import { getSalePrice } from "./utils/pricing";

const TopPicks = () => {
  const { sale } = useContext(SaleContext);
  const [topProducts, setTopProducts] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/api/products/top-picks`)
      .then((res) => {
        setTopProducts(Array.isArray(res.data) ? res.data : []);
      })
      .catch((error) => {
        console.error("Failed to load top picks:", error);
        setTopProducts([]);
      });
  }, []);

  // Show two products at once
  const visibleProducts = 2;

  const nextSlide = () => {
    setCurrentIndex((prev) =>
      Math.min(prev + 1, topProducts.length - visibleProducts)
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => Math.max(prev - 1, 0));
  };

  const maxIndex = Math.max(0, topProducts.length - visibleProducts);

  return (
    <div className="top-picks-container">
      <div className="top-picks-header">
        <h1 className="top-picks-title" id="top-picks">
          CURATED PICKS
        </h1>
      </div>

      {topProducts.length > 0 ? (
        <div className="top-picks-slider">
          <div className="slider-container">
            <div
              className="slider-wrapper"
              style={{
                transform: `translateX(-${currentIndex * 50}%)`,
              }}
            >
              {topProducts.map((product, index) => {
                const salePrice = getSalePrice(product.price, sale);
                const isSaleActive =
                  Boolean(sale) && salePrice < product.price;

                return (
                  <div
                    key={product._id || index}
                    className="slide"
                  >
                    <Link
                      to={`/product/${product._id}`}
                      className="slide-image-link"
                    >
                      <img
                        src={product.images?.main}
                        alt={product.name}
                        className="slide-image"
                      />
                    </Link>

                    <div className="product-card">
                      <h2 className="product-collection">
                        {product.name}
                      </h2>

                      <h2 className="product-name">
                        {product.brand}
                      </h2>

                      <div className="shop-product-price-container">
                        {isSaleActive ? (
                          <>
                            <p className="shop-product-original-price">
                              ₹{product.price}
                            </p>

                            <p className="shop-product-sale-price">
                              ₹{salePrice}
                            </p>

                            {sale?.badgeText && (
                              <div className="tp-sale-badge">
                                {sale.badgeText}
                              </div>
                            )}
                          </>
                        ) : (
                          <p className="top-product-price">
                            ₹{product.price}
                          </p>
                        )}
                      </div>

                      <Link
                        to={`/product/${product._id}`}
                        className="view-product-btn"
                      >
                        View Product
                      </Link>
                    </div>
                  </div>
                );
              })}
            </div>

            {currentIndex > 0 && (
              <button
                onClick={prevSlide}
                className="slider-button left"
                aria-label="Previous products"
              >
                <FiChevronLeft />
              </button>
            )}

            {currentIndex < maxIndex && (
              <button
                onClick={nextSlide}
                className="slider-button right"
                aria-label="Next products"
              >
                <FiChevronRight />
              </button>
            )}
          </div>
        </div>
      ) : (
        <p style={{ textAlign: "center", marginTop: "2rem" }}>
          No Top Picks selected yet ⭐️
        </p>
      )}
    </div>
  );
};

export default TopPicks;
